export const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'croatian',
    locale: 'hr',
    name: 'Hrvatski',
    icon: 'hr',
  },
  {
    languageId: 'albanian',
    locale: 'al',
    name: 'Shqip',
    icon: 'al',
  },
  {
    languageId: 'bosnian',
    locale: 'ba',
    name: 'Bosnian',
    icon: 'ba',
  },
];

export const flags = {
  en: 'https://booking.webbookingpro.com/images/flag/icons8-great-britain-30.png',
  hr: 'https://booking.webbookingpro.com/images/flag/icons8-croatia-30.png',
  it: 'https://booking.webbookingpro.com/images/flag/icons8-italy-30.png',
  sl: 'https://booking.webbookingpro.com/images/flag/icons8-slovenia-30.png',
  sr: 'https://booking.webbookingpro.com/images/flag/icons8-serbia-30.png',
  es: 'https://booking.webbookingpro.com/images/flag/icons8-spain-30.png',
  de: 'https://booking.webbookingpro.com/images/flag/icons8-germany-30.png',
  al: 'https://booking.webbookingpro.com/images/flag/icons8-albanian-30.png',
  fr: 'https://booking.webbookingpro.com/images/flag/icons8-france-30.png',
  ru: 'https://booking.webbookingpro.com/images/flag/icons8-russian-federation-30.png',
  ba: 'https://booking.webbookingpro.com/images/flag/icons8-bosnia-30.png',
  me: 'https://booking.webbookingpro.com/images/flag/icons8-montenegro-30.png',
  mk: 'https://booking.webbookingpro.com/images/flag/icons8-macedonia-30.png',
  ro: 'https://booking.webbookingpro.com/images/flag/icons8-romania-30.png',
  pl: 'https://booking.webbookingpro.com/images/flag/icons8-poland-30.png',
  du: 'https://booking.webbookingpro.com/images/flag/icons8-holand-30.png',
  he: 'https://booking.webbookingpro.com/images/flag/icons8-israel-30.png',
  tr: 'https://booking.webbookingpro.com/images/flag/icons8-turkey-30.png',
};

/*export const general = {
  languages: 'en,hr',
  dateFormat: 'DD/MM/yyyy',
  maxAdults: 4,
  maxChildren: 4,
  defaultDays: 2,
  startDate: '',
};

export const properties = [
  {
    id: 18,
    destination: 'Krapinske Toplice',
    title: { en: 'Hotel Villa Magdaklena' },
    description: { en: 'Description' },
    additionalData: { en: 'add' },
    picture: 'https://secure.webbookingpro.com/images/hotels/hotel_18_kp9jddh0ruxxhubwrxpm.JPG',
    pricePerRoom: 0,
  },
];

export const rooms = [
  {
    id: 13,
    hotelId: 18,
    title: { en: 'Room1 English' },
    description: { en: 'Room1 Description' },
    pictures: { 0: 'https://secure.webbookingpro.com/images/rooms/18_icon_ywphng3nccn2olxbdcfw_thumb.jpg', 1: '', 2: '' },
    maxRooms: 12,
  },
];

export const services = [{ id: 11, hotelId: 18, title: { en: 'BB' } }];

export const packages = [{ hotelId: 18, id: 11, title: { en: 'Package1' }, description: { en: 'Opis' } }];

export const results = [
  { index: 0, roomId: 13, serviceId: 11, priceOrignal: 100, maxRooms: 2, priceFinal: 100, taxes: 10, policyId: 0 },
  { index: 1, roomId: 13, packageId: 11, priceOrignal: 200, maxRooms: 2, priceFinal: 200, taxes: 10, policyId: 0 },
];

export const extras = [
  { id: 100, hotelId: 18, price: 100, model: 1, title: { en: 'extra service en' } },
  { id: 101, hotelId: 18, price: 100, model: 1, title: { en: 'extra service en' } },
];

export const policies = [
  { id: 0, description: { en: 'Uvjeti en' } },
  { id: 1, description: { en: 'Non ref Uvjeti en' } },
];

export const payments = [
  { hotelId: 18, id: 'poa', paymentInfo: 'poa' },
  { hotelId: 18, id: 'online', paymentInfo: 'online' },
];*/

export const applicationCategories = [
  { id: 0, pc: 0, title: { en: 'Pro (usable on multiple workstations)', hr: 'Pro (više računala u mreži)' } },
  { id: 1, pc: 0, title: { en: 'Standard (usable on a single workstation)', hr: 'Standard (jedno računalo)' } },
  { id: 1, pc: 1, title: { en: 'Standard (usable on a single workstation)', hr: 'Standard (jedno računalo)' } },
];

export const discounts = [
  {
    value: 12,
    label: '-10%',
    factor: 0.9,
  },
];
/*export const currencies = [
  { id: 0, title: 'EUR', ratio: 1 },
  { id: 1, title: 'HRK', ratio: 7.53 },
];*/

export const languageCategories = [
  { id: 0, title: 'Hrvatski' },
  { id: 1, title: 'English' },
];

export const propertyCategories = [
  { id: 0, title: { en: 'Hotel', hr: 'Hotel' } },
  { id: 1, title: { en: 'Apartments', hr: 'Apartmani' } },
];

export const roomCategories = [
  { id: 0, pc: 0, title: '1-10' },
  { id: 1, pc: 0, title: '11-25' },
  { id: 2, pc: 0, title: '26-50' },
  { id: 3, pc: 0, title: '51-100' },
  { id: 4, pc: 0, title: '101-200' },
  { id: 5, pc: 0, title: '201-300' },
  { id: 6, pc: 0, title: '301-' },
  { id: 0, pc: 1, title: '1-5' },
  { id: 1, pc: 1, title: '6-10' },
  { id: 2, pc: 1, title: '11-20' },
];

export const solutionsCategories = [
  { id: 0, title: { en: 'Basic', hr: 'Osnovno' } },
  { id: 1, title: { en: 'Cloud/Mobile Solutions', hr: 'Cloud/Mobilni pristup' } },
  { id: 2, title: { en: 'Channel Manager', hr: 'Channel Manager' } },
  { id: 3, title: { en: 'Additional Extensions', hr: 'Dodatne poveznice' } },
];

export const solutionsData = [
  {
    id: 0,
    categoryId: 0,
    title: { en: 'Simple module', hr: 'Osnovni modul' },
    description: { en: 'Simple moule description', hr: 'Osnovni modul opis' },
    prices: [
      { rc: 0, pc: 0, value: 100, setup: 0 },
      { rc: 1, pc: 0, value: 200, setup: 0 },
      { rc: 2, pc: 0, value: 300, setup: 0 },
      { rc: 3, pc: 0, value: 400, setup: 0 },
    ],
  },
  {
    id: 1,
    categoryId: 2,
    title: { en: 'Simple module with Accept', hr: 'Osnovni modul s potvrdom' },
    description: { en: 'Simple module with Accept description', hr: 'Osnovni modul s potvrdom opis' },
    acceptText: {
      en: 'Tekst or html that user has to accept before checking.',
      hr: 'tekst ili html kojeg korisnik mora potvrditi prije označavanja',
    },
    prices: [
      { rc: 0, pc: 0, value: 50, setup: 10 },
      { rc: 1, pc: 0, value: 100, setup: 10 },
      { rc: 2, pc: 0, value: 200, setup: 10 },
      { rc: 3, pc: 0, value: 300, setup: 10 },
    ],
  },
  {
    id: 2,
    categoryId: 3,
    title: { en: 'Simple module with Individual price', hr: 'Osnovni modul s individualnom cijenom' },
    description: { en: 'Simple module with Individual price description', hr: 'Osnovni modul s individualnom cijenom' },
    acceptText: {
      en: 'Tekst or html that user has to accept before checking.',
      hr: 'tekst ili html kojeg korisnik mora potvrditi prije označavanja',
    },
  },
  {
    id: 3,
    categoryId: 1,
    title: { en: 'Modul with options ', hr: 'Modul s opcijama' },
    description: { en: 'Modul with options description', hr: 'Modul s opcijama opis' },
    variants: [
      { vid: 0, title: { en: 'Web Access ', hr: 'Web Access' } },
      { vid: 1, title: { en: 'Mobile Access ', hr: 'Mobile Access' } },
      { vid: 2, title: { en: 'Web+Mobile Access ', hr: 'Web+Mobile Access' } },
    ],
    prices: [
      { vid: 0, rc: 0, pc: 0, value: 50, setup: 10 },
      { vid: 0, rc: 1, pc: 0, value: 100, setup: 10 },
      { vid: 0, rc: 2, pc: 0, value: 200, setup: 10 },
      { vid: 0, rc: 3, pc: 0, value: 300, setup: 10 },
      { vid: 1, rc: 0, pc: 0, value: 50, setup: 10 },
      { vid: 1, rc: 1, pc: 0, value: 100, setup: 10 },
      { vid: 1, rc: 2, pc: 0, value: 200, setup: 10 },
      { vid: 1, rc: 3, pc: 0, value: 300, setup: 10 },
      { vid: 2, rc: 0, pc: 0, value: 100, setup: 10 },
      { vid: 2, rc: 1, pc: 0, value: 200, setup: 10 },
      { vid: 2, rc: 2, pc: 0, value: 300, setup: 10 },
      { vid: 2, rc: 3, pc: 0, value: 400, setup: 10 },
    ],
  },
  {
    id: 4,
    categoryId: 1,
    title: { en: 'Modul that requires another', hr: 'Modul koji zahtjeva drugi' },
    description: { en: 'Hotel Mobile Analytics description', hr: 'Hotel Mobile Analytics opis' },
    requires: 3,
    prices: [
      { rc: 0, pc: 0, value: 50, setup: 10 },
      { rc: 1, pc: 0, value: 100, setup: 10 },
      { rc: 2, pc: 0, value: 200, setup: 10 },
      { rc: 3, pc: 0, value: 300, setup: 10 },
    ],
  },
  {
    id: 5,
    categoryId: 2,
    title: { en: 'On the spot training', hr: 'Edukacija na terenu' },
    description: { en: 'On the spot training description', hr: 'Edukacija na terenu opis' },
    prices: [
      {
        rc: 0,
        pc: 0,
        value: 0,
        setup: 1000,
        addInfo: { en: 'The price does not include travel costs.', hr: 'Cijena ne uključuje troškove boravka.' },
      },
      {
        rc: 1,
        pc: 0,
        value: 0,
        setup: 1000,
        addInfo: { en: 'The price does not include travel costs.', hr: 'Cijena ne uključuje troškove boravka.' },
      },
      {
        rc: 2,
        pc: 0,
        value: 0,
        setup: 1000,
        addInfo: { en: 'The price does not include travel costs.', hr: 'Cijena ne uključuje troškove boravka.' },
      },
      {
        rc: 3,
        pc: 0,
        value: 0,
        setup: 1000,
        addInfo: { en: 'The price does not include travel costs.', hr: 'Cijena ne uključuje troškove boravka.' },
      },
    ],
  },
];

export const countries = [
  { id: 'AF', value: 'Afghanistan' },
  { id: 'AX', value: 'Åland Islands' },
  { id: 'AL', value: 'Albania' },
  { id: 'DZ', value: 'Algeria' },
  { id: 'AS', value: 'American Samoa' },
  { id: 'AD', value: 'Andorra' },
  { id: 'AO', value: 'Angola' },
  { id: 'AI', value: 'Anguilla' },
  { id: 'AQ', value: 'Antarctica' },
  { id: 'AG', value: 'Antigua and Barbuda' },
  { id: 'AR', value: 'Argentina' },
  { id: 'AM', value: 'Armenia' },
  { id: 'AW', value: 'Aruba' },
  { id: 'AU', value: 'Australia' },
  { id: 'AT', value: 'Austria' },
  { id: 'AZ', value: 'Azerbaijan' },
  { id: 'BS', value: 'Bahamas' },
  { id: 'BH', value: 'Bahrain' },
  { id: 'BD', value: 'Bangladesh' },
  { id: 'BB', value: 'Barbados' },
  { id: 'BY', value: 'Belarus' },
  { id: 'BE', value: 'Belgium' },
  { id: 'BZ', value: 'Belize' },
  { id: 'BJ', value: 'Benin' },
  { id: 'BM', value: 'Bermuda' },
  { id: 'BT', value: 'Bhutan' },
  { id: 'BO', value: 'Bolivia' },
  { id: 'BQ', value: 'Bonaire, Sint Eustatius and Saba' },
  { id: 'BA', value: 'Bosnia and Herzegowina' },
  { id: 'BW', value: 'Botswana' },
  { id: 'BV', value: 'Bouvet Island' },
  { id: 'BR', value: 'Brazil' },
  { id: 'IO', value: 'British Indian Ocean Territory' },
  { id: 'VG', value: 'British Virgin Islands' },
  { id: 'BN', value: 'Brunei Darussalam' },
  { id: 'BG', value: 'Bulgaria' },
  { id: 'BF', value: 'Burkina Faso' },
  { id: 'BI', value: 'Burundi' },
  { id: 'KH', value: 'Cambodia' },
  { id: 'CM', value: 'Cameroon' },
  { id: 'CA', value: 'Canada' },
  { id: 'CV', value: 'Cape Verde' },
  { id: 'KY', value: 'Cayman Islands' },
  { id: 'CF', value: 'Central African Republic' },
  { id: 'TD', value: 'Chad' },
  { id: 'CL', value: 'Chile' },
  { id: 'CN', value: 'China' },
  { id: 'CX', value: 'Christmas Island' },
  { id: 'CC', value: 'Cocos (Keeling) Islands' },
  { id: 'CO', value: 'Colombia' },
  { id: 'KM', value: 'Comoros' },
  { id: 'CD', value: 'Congo, The Democratic Republic of the' },
  { id: 'CK', value: 'Cook Islands' },
  { id: 'CR', value: 'Costa Rica' },
  { id: 'CI', value: "Cote D'ivoire" },
  { id: 'HR', value: 'Croatia' },
  { id: 'CU', value: 'Cuba' },
  { id: 'CW', value: 'Curaçao' },
  { id: 'CY', value: 'Cyprus' },
  { id: 'CZ', value: 'Czech Republic' },
  { id: 'DK', value: 'Denmark' },
  { id: 'DJ', value: 'Djibouti' },
  { id: 'DM', value: 'Dominica' },
  { id: 'DO', value: 'Dominican Republic' },
  { id: 'TL', value: 'East Timor' },
  { id: 'EC', value: 'Ecuador' },
  { id: 'EG', value: 'Egypt' },
  { id: 'SV', value: 'El Salvador' },
  { id: 'GQ', value: 'Equatorial Guinea' },
  { id: 'ER', value: 'Eritrea' },
  { id: 'EE', value: 'Estonia' },
  { id: 'ET', value: 'Ethiopia' },
  { id: 'FK', value: 'Falkland Islands (Malvinas)' },
  { id: 'FO', value: 'Faroe Islands' },
  { id: 'FJ', value: 'Fiji' },
  { id: 'FI', value: 'Finland' },
  { id: 'FR', value: 'France' },
  { id: 'GF', value: 'French Guiana' },
  { id: 'PF', value: 'French Polynesia' },
  { id: 'TF', value: 'French Southern Territories' },
  { id: 'GA', value: 'Gabon' },
  { id: 'GM', value: 'Gambia' },
  { id: 'GE', value: 'Georgia' },
  { id: 'DE', value: 'Germany' },
  { id: 'GH', value: 'Ghana' },
  { id: 'GI', value: 'Gibraltar' },
  { id: 'GR', value: 'Greece' },
  { id: 'GL', value: 'Greenland' },
  { id: 'GD', value: 'Grenada' },
  { id: 'GP', value: 'Guadeloupe' },
  { id: 'GU', value: 'Guam' },
  { id: 'GT', value: 'Guatemala' },
  { id: 'GG', value: 'Guernsey' },
  { id: 'GN', value: 'Guinea' },
  { id: 'GW', value: 'Guinea-Bissau' },
  { id: 'GY', value: 'Guyana' },
  { id: 'HT', value: 'Haiti' },
  { id: 'HM', value: 'Heard and McDonald Islands' },
  { id: 'HN', value: 'Honduras' },
  { id: 'HK', value: 'Hong Kong' },
  { id: 'HU', value: 'Hungary' },
  { id: 'IS', value: 'Iceland' },
  { id: 'IN', value: 'India' },
  { id: 'ID', value: 'Indonesia' },
  { id: 'IQ', value: 'Iraq' },
  { id: 'IE', value: 'Ireland' },
  { id: 'IR', value: 'Islamic Republic of Iran' },
  { id: 'IM', value: 'Isle of Man' },
  { id: 'IL', value: 'Israel' },
  { id: 'IT', value: 'Italy' },
  { id: 'JM', value: 'Jamaica' },
  { id: 'JP', value: 'Japan' },
  { id: 'JE', value: 'Jersey' },
  { id: 'JO', value: 'Jordan' },
  { id: 'KZ', value: 'Kazakhstan' },
  { id: 'KE', value: 'Kenya' },
  { id: 'KI', value: 'Kiribati' },
  { id: 'KP', value: 'Korea, Dem. Peoples Rep of' },
  { id: 'KR', value: 'Korea, Republic of' },
  { id: 'KW', value: 'Kuwait' },
  { id: 'KG', value: 'Kyrgyzstan' },
  { id: 'LA', value: 'Laos' },
  { id: 'LV', value: 'Latvia' },
  { id: 'LB', value: 'Lebanon' },
  { id: 'LS', value: 'Lesotho' },
  { id: 'LR', value: 'Liberia' },
  { id: 'LY', value: 'Libyan Arab Jamahiriya' },
  { id: 'LI', value: 'Liechtenstein' },
  { id: 'LT', value: 'Lithuania' },
  { id: 'LU', value: 'Luxembourg' },
  { id: 'MO', value: 'Macau' },
  { id: 'MK', value: 'Macedonia' },
  { id: 'MG', value: 'Madagascar' },
  { id: 'MW', value: 'Malawi' },
  { id: 'MY', value: 'Malaysia' },
  { id: 'MV', value: 'Maldives' },
  { id: 'ML', value: 'Mali' },
  { id: 'MT', value: 'Malta' },
  { id: 'MH', value: 'Marshall Islands' },
  { id: 'MQ', value: 'Martinique' },
  { id: 'MR', value: 'Mauritania' },
  { id: 'MU', value: 'Mauritius' },
  { id: 'YT', value: 'Mayotte' },
  { id: 'MX', value: 'Mexico' },
  { id: 'FM', value: 'Micronesia' },
  { id: 'MD', value: 'Moldova, Republic of' },
  { id: 'MC', value: 'Monaco' },
  { id: 'MN', value: 'Mongolia' },
  { id: 'ME', value: 'Montenegro' },
  { id: 'MS', value: 'Montserrat' },
  { id: 'MA', value: 'Morocco' },
  { id: 'MZ', value: 'Mozambique' },
  { id: 'MM', value: 'Myanmar' },
  { id: 'NA', value: 'Namibia' },
  { id: 'NR', value: 'Nauru' },
  { id: 'NP', value: 'Nepal' },
  { id: 'NL', value: 'Netherlands' },
  { id: 'AN', value: 'Netherlands Antilles' },
  { id: 'NC', value: 'New Caledonia' },
  { id: 'NZ', value: 'New Zealand' },
  { id: 'NI', value: 'Nicaragua' },
  { id: 'NE', value: 'Niger' },
  { id: 'NG', value: 'Nigeria' },
  { id: 'NU', value: 'Niue' },
  { id: 'NF', value: 'Norfolk Island' },
  { id: 'MP', value: 'Northern Mariana Islands' },
  { id: 'NO', value: 'Norway' },
  { id: 'OM', value: 'Oman' },
  { id: 'PK', value: 'Pakistan' },
  { id: 'PW', value: 'Palau' },
  { id: 'PS', value: 'Palestine, State of' },
  { id: 'PA', value: 'Panama' },
  { id: 'PG', value: 'Papua New Guinea' },
  { id: 'PY', value: 'Paraguay' },
  { id: 'PE', value: 'Peru' },
  { id: 'PH', value: 'Philippines' },
  { id: 'PN', value: 'Pitcairn' },
  { id: 'PL', value: 'Poland' },
  { id: 'PT', value: 'Portugal' },
  { id: 'PR', value: 'Puerto Rico' },
  { id: 'QA', value: 'Qatar' },
  { id: 'RE', value: 'Reunion' },
  { id: 'RO', value: 'Romania' },
  { id: 'RU', value: 'Russian Federation' },
  { id: 'RW', value: 'Rwanda' },
  { id: 'BL', value: 'Saint Barthélemy' },
  { id: 'LC', value: 'Saint Lucia' },
  { id: 'MF', value: 'Saint Martin (French part)' },
  { id: 'WS', value: 'Samoa' },
  { id: 'SM', value: 'San Marino' },
  { id: 'ST', value: 'Sao Tome and Principe' },
  { id: 'SA', value: 'Saudi Arabia' },
  { id: 'SN', value: 'Senegal' },
  { id: 'RS', value: 'Serbia' },
  { id: 'SC', value: 'Seychelles' },
  { id: 'SL', value: 'Sierra Leone' },
  { id: 'SG', value: 'Singapore' },
  { id: 'SX', value: 'Sint Maarten (Dutch part)' },
  { id: 'SK', value: 'Slovakia' },
  { id: 'SI', value: 'Slovenia' },
  { id: 'SB', value: 'Solomon Islands' },
  { id: 'SO', value: 'Somalia' },
  { id: 'ZA', value: 'South Africa' },
  { id: 'GS', value: 'South Georgia and the South Sandwich Islands' },
  { id: 'SS', value: 'South Sudan' },
  { id: 'ES', value: 'Spain' },
  { id: 'LK', value: 'Sri Lanka' },
  { id: 'SH', value: 'St. Helena' },
  { id: 'KN', value: 'St. Kitts and Nevis' },
  { id: 'PM', value: 'St. Pierre and Miquelon' },
  { id: 'VC', value: 'St. Vincent and the Grenadines' },
  { id: 'SD', value: 'Sudan' },
  { id: 'SR', value: 'Suriname' },
  { id: 'SJ', value: 'Svalbard and Jan Mayen Islands' },
  { id: 'SZ', value: 'Swaziland' },
  { id: 'SE', value: 'Sweden' },
  { id: 'CH', value: 'Switzerland' },
  { id: 'SY', value: 'Syrian Arab Republic' },
  { id: 'TW', value: 'Taiwan' },
  { id: 'TJ', value: 'Tajikistan' },
  { id: 'TZ', value: 'Tanzania, United Republic of' },
  { id: 'TH', value: 'Thailand' },
  { id: 'TG', value: 'Togo' },
  { id: 'TK', value: 'Tokelau' },
  { id: 'TO', value: 'Tonga' },
  { id: 'TT', value: 'Trinidad and Tobago' },
  { id: 'TN', value: 'Tunisia' },
  { id: 'TR', value: 'Turkey' },
  { id: 'TM', value: 'Turkmenistan' },
  { id: 'TC', value: 'Turks and Caicos Islands' },
  { id: 'TV', value: 'Tuvalu' },
  { id: 'UG', value: 'Uganda' },
  { id: 'UA', value: 'Ukraine' },
  { id: 'AE', value: 'United Arab Emirates' },
  { id: 'GB', value: 'United Kingdom' },
  { id: 'US', value: 'United States' },
  { id: 'UM', value: 'United States Minor Outlying Islands' },
  { id: 'VI', value: 'United States Virgin Islands' },
  { id: 'UY', value: 'Uruguay' },
  { id: 'UZ', value: 'Uzbekistan' },
  { id: 'VU', value: 'Vanuatu' },
  { id: 'VA', value: 'Vatican City State' },
  { id: 'VE', value: 'Venezuela' },
  { id: 'VN', value: 'Vietnam' },
  { id: 'WF', value: 'Wallis And Futuna Islands' },
  { id: 'EH', value: 'Western Sahara' },
  { id: 'YE', value: 'Yemen' },
  { id: 'ZR', value: 'Zaire' },
  { id: 'ZM', value: 'Zambia' },
  { id: 'ZW', value: 'Zimbabwe' },
];
